import { render, staticRenderFns } from "./CustomerPay.vue?vue&type=template&id=b76f8bb0&scoped=true&"
import script from "./CustomerPay.vue?vue&type=script&lang=js&"
export * from "./CustomerPay.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPay.vue?vue&type=style&index=0&id=b76f8bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76f8bb0",
  null
  
)

export default component.exports